import React from 'react';
import { WizardState } from '../../../hooks/useZakatWizard';
import { Input } from '../../ui/Input';
import { Card } from '../../ui/Card';
interface CashStepProps {
  state: WizardState;
  updateState: (updates: Partial<WizardState>) => void;
}
// Helper to display number values in inputs - shows empty string for 0 (placeholder visible)
const displayVal = (v: number) => v === 0 ? '' : v;
export function CashStep({
  state,
  updateState
}: CashStepProps) {
  return <div className="space-y-6" data-id="element-280">
      <div className="mb-6" data-id="element-281">
        <h2 className="text-2xl font-bold text-gray-900 font-serif mb-2" data-id="element-282">
          My Cash
        </h2>
        <p className="text-gray-600" data-id="element-283">
          Include all liquid cash you have access to—checking accounts, savings
          accounts, cash on hand, PayPal, Venmo, and any other cash equivalents.
        </p>
      </div>

      <Card className="space-y-6" data-id="element-284">
        <Input label="Cash on Hand" prefix="$" type="number" placeholder="0.00" value={displayVal(state.cashInHand)} onChange={e => updateState({
        cashInHand: parseFloat(e.target.value) || 0
      })} data-id="element-285" />

        <Input label="Checking Accounts" prefix="$" type="number" placeholder="0.00" value={displayVal(state.checkingAccount)} onChange={e => updateState({
        checkingAccount: parseFloat(e.target.value) || 0
      })} data-id="element-286" />

        <Input label="Savings Accounts" prefix="$" type="number" placeholder="0.00" value={displayVal(state.savingsAccount)} onChange={e => updateState({
        savingsAccount: parseFloat(e.target.value) || 0
      })} data-id="element-287" />

        <Input label="Other (PayPal, Venmo, Digital Wallets)" prefix="$" type="number" placeholder="0.00" value={displayVal(state.otherCash)} onChange={e => updateState({
        otherCash: parseFloat(e.target.value) || 0
      })} data-id="element-288" />
      </Card>
    </div>;
}